import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "commonBorderDialogContainer" }
const _hoisted_2 = { class: "commonBorderDialogContent" }

import { computed } from 'vue'
import {useStore} from 'vuex';

//////////////props//////////////

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  hasBorderColor:{
    required: false,
    type: Boolean,
    default: true,
  },
  viewFocused:{
    required: false,
    type: Boolean,
    default: false,
  },
  hasBackGroundColor:{
    required: false,
    type: Boolean,
    default: true,
  },
  useClipPath:{
    required: false,
    type: Boolean,
    default: false,
  },
  showcaseModule: {
    type: Boolean,
    default: true,
  }
},
  setup(__props) {

const props = __props;

//状态
const store = useStore();

//////////////计算属性//////////////
// const backgroundColor = computed(() => {
//   return store.state.viewData.backgroundColor;
// })
// const neutralColor = computed(() => {
//   return store.state.viewData.neutralColor;
// })
// const basicColor = computed(() => {
//   return store.state.viewData.basicColor;
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showcaseModule)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({'commonBorderDialogBody':true,'commonBorderDialogEmptyCenter':props.useClipPath})
        }, null, 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({'commonBorderDialogBody':true,'commonBorderDialogEmptyCenter':props.useClipPath}),
          style: {"background-color":"#1f1f1f"}
        }, null, 2)),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})